import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71cfc01e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-page-container" }
const _hoisted_2 = {
  key: 0,
  class: "landing-page"
}
const _hoisted_3 = { class: "landing-page-title" }
const _hoisted_4 = {
  key: 0,
  class: "landing-page-blocks"
}

import { ref } from 'vue';
import { useRoute } from 'vue-router';

import { contentfulService } from '@/services';
import LandingContentBlock from '@/components/Landing/LandingContentBlock.vue';
import { useMeta } from '@/store/useMeta';
import { LandingPage } from '@functions/model/landing-page';


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingPage',
  async setup(__props) {

let __temp: any, __restore: any

const page = ref<LandingPage | null>(null);
const route = useRoute();

if (route.params.slug && typeof route.params.slug === 'string') {
  page.value = (
  ([__temp,__restore] = _withAsyncContext(() => contentfulService.getLandingPageBySlug(route.params.slug))),
  __temp = await __temp,
  __restore(),
  __temp
);
}

useMeta({
  title: page.value?.title,
  description: page.value?.title,
  canonical: `/landing/${page.value?.slug}`
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (page.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("header", null, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(page.value.title), 1)
          ]),
          (page.value.contentBlocks)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.contentBlocks, (block, index) => {
                  return (_openBlock(), _createBlock(LandingContentBlock, {
                    key: index,
                    block: block
                  }, null, 8, ["block"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})